import React from "react";

import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";
import { MobilePlatform } from "@state/stores/types";

export default function SearchButton() {
	const { searchStore } = useRootAppStore<MobilePlatform>();

	return (
		<Button
			type="button"
			onClick={() => {
				searchStore.searchButtonOnClick();
			}}
			atClassName="headerBtn--Search-Toggle"
			className="btn--square btn--square--sml btn--ghost"
			iconOnly
			iconClassName="u-icon--sml u-icon--search--reg u-color--core--snow"
		/>
	);
}
